import { render, staticRenderFns } from "./TableScroll.vue?vue&type=template&id=ccd5fc74&"
import script from "./TableScroll.vue?vue&type=script&lang=js&"
export * from "./TableScroll.vue?vue&type=script&lang=js&"
import style0 from "./TableScroll.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports